<!-- eslint-disable vue/multi-word-component-names -->
<!-- 通用按钮组件 
     本Icon组件为 vue3 + ts 原生封装组件，未采用任何其他组件库二开
     属性有： 
     1. svgType 默认图标类型 默认无图标 目前本地内：
        add. 添加 
        document. 文档
     2. svgUrl 自定义SVG路径
     3. iconStyle 自定义SVG图标样式(宽、高等自适应等比放缩，类比图片img标签)
-->
<template>
  <div :class="`icon-frame ${iconBox}`">
    <!-- 如果有自定义图标路径，则使用img标签显示SVG -->
    <img v-if="svgUrl !== ''" :src="svgUrl" class="icon" :style="iconStyle" />
    <!-- 否则，使用内置的SVG组件 -->
    <component v-else-if="svgUrl === ''" :is="svgComponent" class="icon" :style="iconStyle" />
  </div>
</template>
<script setup lang="ts">
import { computed, defineAsyncComponent, PropType } from 'vue'

// 定义Style接口
interface Style {
  color?: string
  fontSize?: string
  [key: string]: string | undefined // 用于捕获其他所有的CSS属性
}

// 定义属性和事件
const props = defineProps({
  /** 默认图标类型 默认无图标 目前本地内：1 add. 添加 ; 2 document. 文档*/
  svgType: {
    type: String,
    default: ''
  },
  /** 自定义SVG路径 */
  svgUrl: {
    type: String,
    default: ''
  },
  /** 自定义图标样式 */
  iconStyle: {
    type: Object as PropType<Style>,
    default() {
      return {}
    }
  },
  /** 自定义图标样式 */
  iconBox: {
    type: String,
    default() {
      return ''
    }
  }
})

// 使用import.meta.glob预先定义所有可能的SVG组件
// @ts-expect-error
const svgModules = import.meta.glob<any>('@/assets/icons/*.svg')

// 计算路径、将其变成组件，供上面的component组件使用
const svgComponent = computed(() => {
  // 检查props.svgType是否存在，并且在svgModules中有对应的模块
  // 因为@/解析出来的地址为实际地址，直接使用`@/components/...不现实`，这里使用截断icons前的路径进行拼接
  const readyToDealPath = String(Reflect.ownKeys(svgModules)[0]).split('/')
  const iconsStringIndex = readyToDealPath.indexOf('icons')
  const beforeIconPath = readyToDealPath.slice(0, iconsStringIndex).join('/')
  const importPath = `${beforeIconPath}/icons/${props.svgType}.svg`
  if (props.svgType && svgModules[importPath]) {
    // 使用defineAsyncComponent动态导入SVG组件
    return defineAsyncComponent(svgModules[importPath])
  }
  // 如果没有匹配的svgType，返回null
  return null
})
</script>

<style scoped lang="scss">
.icon {
  width: 1em;
  height: 1em;
  margin-right: 5px;
}
</style>
